var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "report-generator" },
    [
      _c("div", { attrs: { id: "report" } }, [
        _c("section", { staticClass: "section" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "columns mb-6" }, [
              _c("div", { staticClass: "column is-half" }, [
                _c("div", { staticClass: "content" }, [
                  _c("div", { staticClass: "is-size-5" }, [
                    _vm._v("Client Name: " + _vm._s(_vm.details.clientName)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "is-size-5" }, [
                    _vm._v("Address: " + _vm._s(_vm.details.address)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "is-size-5" }, [
                    _vm._v("Postcode: " + _vm._s(_vm.details.postcode)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "has-text-right" }, [
                  _c("div", { staticClass: "is-size-5" }, [
                    _vm._v(_vm._s(_vm._f("title")(_vm.builderName))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "is-size-5" }, [
                    _vm._v(_vm._s(_vm.contactEmail)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "is-size-5" }, [
                    _vm._v(_vm._s(_vm.contactNumber)),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "content my-6" }, [
              _c("p", [
                _vm._v(
                  "\n            The job type described in this estimate is " +
                    _vm._s(_vm.jobType) +
                    ".\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n            This is a calculation of materials, plant\n            and labour for estimating purposes only\n            (not a fixed price model).\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n            The is estimate is based on the information provided\n            and the responsibility is solely with you as the\n            customer to ensure the correct information is inputted\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n            This is a guide only and is subject to\n            change depending on the final design and\n            specification.\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "table is-fullwidth my-6" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.buildStages, function (buildStage, index) {
                  return _c("tr", { key: index }, [
                    _c("td", { staticStyle: { width: "550px" } }, [
                      _c(
                        "div",
                        { staticClass: "build-stage-with-components" },
                        [
                          _c(
                            "div",
                            { staticClass: "is-size-5 has-text-weight-bold" },
                            [_vm._v(_vm._s(buildStage.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "work-sections" },
                            [
                              buildStage.workSectionsIncluded.length > 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "is-size-7 has-text-weight-bold",
                                    },
                                    [_vm._v("Includes: ")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(
                                buildStage.workSectionsIncluded,
                                function (workSection, index) {
                                  return _c(
                                    "span",
                                    { key: index, staticClass: "is-size-7" },
                                    [
                                      _vm._v(_vm._s(workSection)),
                                      index <
                                      buildStage.workSectionsIncluded.length - 1
                                        ? _c("span", [_vm._v(", ")])
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm._f("currencyNotReduced")(buildStage.value))
                      ),
                    ]),
                  ])
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _vm.pcSums.length > 0
              ? _c("div", { staticStyle: { "page-break-after": "always" } })
              : _vm._e(),
            _vm._v(" "),
            _vm.pcSums.length > 0
              ? _c(
                  "div",
                  { staticClass: "has-text-black is-size-5 mb-3 mt-6" },
                  [
                    _vm._v("Extra Provisional Sums"),
                    _c("span", { staticClass: "is-size-7" }, [
                      _vm._v("(not included in the build stage cost)"),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.pcSums.length > 0
              ? _c("table", { staticClass: "table is-fullwidth mb-6" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.pcSums, function (pcSum, index) {
                      return _c("tr", { key: index }, [
                        _c("td", { staticStyle: { width: "550px" } }, [
                          _vm._v(_vm._s(pcSum.name)),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm._f("currencyNotReduced")(pcSum.value))
                          ),
                        ]),
                      ])
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "content my-6 w-100 is-pulled-right" }, [
              _c(
                "p",
                {
                  staticClass:
                    "is-size-5 has-text-weight-bold has-text-primary",
                },
                [
                  _vm._v(
                    "\n            Total: " +
                      _vm._s(
                        _vm._f("currencyNotReduced")(_vm.totalWithoutVAT)
                      ) +
                      " (excluding VAT).\n          "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("b-button", { on: { click: _vm.generatePDF } }, [
        _vm._v("Generate and download my report"),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "has-text-centered" }, [
      _c("h1", { staticClass: "title is-2 has-text-black my-6" }, [
        _vm._v("PRIMARY COST ESTIMATE"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c(
          "th",
          { staticClass: "has-text-white", staticStyle: { width: "550px" } },
          [_vm._v("Build Stage")]
        ),
        _vm._v(" "),
        _c("th", { staticClass: "has-text-white" }, [_vm._v("Cost")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c(
          "th",
          { staticClass: "has-text-white", staticStyle: { width: "550px" } },
          [_vm._v("Item Name")]
        ),
        _vm._v(" "),
        _c("th", { staticClass: "has-text-white" }, [_vm._v("Cost")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }